import React from 'react';
import {
  Button,
  IconButton,
  Paper,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Tooltip,
  Divider,
  Checkbox,
  InputLabel,
  MenuItem,
  FormControl,
  Select
} from '@mui/material';

import { Add, Delete, Edit } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { DataGrid } from '@mui/x-data-grid';
import { ptBR } from "@mui/x-data-grid/locales";
import { D, SearchField, ConfirmDialog, TransferList, C } from '../include';
import _ from 'underscore';

const strFillPattern = ". "

class EditQuestion extends React.Component {
  constructor(props) {
    super(props); 
    
     

    this.state = { 
      questionID: this.props.row ? this.props.row.id : -1,
      label: this.props.row ? this.props.row.label : '', 
      label_asking_complement: this.props.row ? this.props.row.label_asking_complement : '', 
      type: this.props.row ? this.props.row.type : -1,
      choices_selected: null,
      choices_unselected: null
    };
  }



  componentDidMount() {
    var theID = this.props.row ? this.props.row.id : -1;
    this.setState({ loading: true });   
    this.props.api
      .get('/Question/' + theID)
      .then((r) => {
        var selected = [];
        var unselected = [];
        for(let row in r.selected){
          selected.push (r.selected[row].id + strFillPattern + r.selected[row].label );
        }
        for(let row in r.unselected){
          unselected.push( r.unselected[row].id + strFillPattern + r.unselected[row].label );
        }
        this.setState({
          choices_selected: selected,
          choices_unselected: unselected,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }
  
  

  handleSubmit = () => {
    var choicesIDs = [];
    for(var row in this.state.choices_selected){
          var v = this.state.choices_selected[row].split(strFillPattern)
          choicesIDs.push(v[0])
    }
    
    if (!this.props.edit) {
      this.props.api
        .post('/Questions/', { label: this.state.label, label_asking_complement: this.state.label_asking_complement, type: this.state.type, choicesIDs: choicesIDs })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Registro criado com sucesso');
        })
        .catch(() => this.props.alert('Ocorreu um erro ao criar o registro'));
    } else {
      this.props.api
        .put('/Question/' + this.props.row.id, { id: this.props.row.id, label: this.state.label, label_asking_complement: this.state.label_asking_complement, type: this.state.type, choicesIDs: choicesIDs })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert(r.message);
        })
        .catch(() => this.props.alert('Ocorreu um erro ao salvar alterações'));
    }
  };
  
    
  handleChoicesChange = (v) => {
    this.setState({choices_selected: v})
  };
  

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <DialogTitle style={{ minWidth: '400px' }}>
          {this.props.edit ? 'Editar Pergunta' : 'Adicionar Pergunta'}
        </DialogTitle>
        <DialogContent>
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Cabeçalho"
            value={this.state.label}
            onChange={(e) => this.setState({ label: e.target.value })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Complemento"
            value={this.state.label_asking_complement}
            onChange={(e) => this.setState({ label_asking_complement: e.target.value })}
          />
          <D h="1rem" />
          <FormControl fullWidth>
            <InputLabel id="select-type">Tipo</InputLabel>
            <Select
              labelId="select-type"
              id="select-t"
              value={this.state.type}
              label="Tipo"
              onChange={(e) => this.setState({type: e.target.value})}
            >
              {Object.keys(C.QuestionType).map(key => {
                  return <MenuItem key={key} value={key}>{C.QuestionType[key]}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <D h="1rem" />
          <FormControl fullWidth>
          { this.state.choices_selected && this.state.choices_unselected &&
            <TransferList
              caption="Escolhas" 
              alternative={this.state.choices_unselected}
              assignment={this.state.choices_selected}
              onAssignmentChange={this.handleChoicesChange}
            />
          }
          </FormControl>
      
          <D h="2rem" />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>
            Cancelar
          </Button>
          <Button variant="outlined" color="primary" type="submit">
            Salvar
          </Button>
        </DialogActions>
      </form>
    );
  }
}

export class Question extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchField: '',
      dataTable: [],
      loading: true,
      page: 0,
      pageSize: 25,
      totalRows: 0,
      selectedRows: [],
    };

    this.columns = [
      ...(this.props.permission === 'w'
        ? [
            {
              field: "check",
              headerName: "Seleção",
              width: 100,
              sortable: false,
              renderCell: (params) => (
                <Checkbox checked={this.state.selectedRows.includes(params.row) } onChange={() => this.onRowClick(params.row)} />
              ),
            },
          ]
        : []),
      { field: 'id', headerName: 'ID', width: 70 },
      { field: 'label', headerName: 'Cabeçalho', width: 300 },
      { field: 'typestring', headerName: 'Tipo', width: 100 },
      { field: 'label_asking_complement', headerName: 'Complemento', width: 150 },
    ];
  }

  componentDidMount() {
    this.updateData();
  }

  updateData = (page = this.state.page, pageSize = this.state.pageSize, searchField = this.state.searchField) => {
    this.setState({ loading: true });
    this.props.api
      .get('/Questions', { params: { page, pageSize, search: searchField } })
      .then((r) => {
        for(var row in r.questions){
          r.questions[row]["typestring"] = C.QuestionType[ r.questions[row]["type"] ];
          if(r.questions[row]["label_asking_complement"] === "null")
            r.questions[row]["label_asking_complement"] = '';
          
        }
        this.setState({
          dataTable: r.questions || [],
          totalRows: Number(r.total) || 0,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleSearch = () => {
    this.setState({ page: 0 }, () => {
      this.updateData(0, this.state.pageSize, this.state.searchField);
    });
  };

  handlePaginationModelChange = (newpagemodel, reason) => {
    var pageSizeChanged = (newpagemodel.pageSize === this.state.pageSize) ? false : true
        
    this.setState({ page: newpagemodel.page, pageSize: newpagemodel.pageSize }, () => {
      this.updateData(pageSizeChanged ? 0 : newpagemodel.page, newpagemodel.pageSize);
    });
  };

  onRowClick = (i) => {
    this.setState({
      selectedRows: this.state.selectedRows.includes(i) ? _.without(this.state.selectedRows, i) : _.union(this.state.selectedRows, [i])
    });
  };
  
  render() {
    const { searchField, dataTable, loading, page, pageSize, totalRows } = this.state;

    return (
      <D className="col e aF scD" style={{ padding: '2rem' }}>
        <D className="row w aF">
          <SearchField
            value={searchField}
            onChange={(v) => this.setState({ searchField: v })}
        />
        <Tooltip title="Pesquisar" arrow>
          <IconButton sx={{ marginLeft: '12px' }} onClick={this.handleSearch}>
            <SearchIcon />
          </IconButton>
        </Tooltip>
              
        {this.props.permission === 'w' && (
          <> 
              <Divider sx={{ paddingRight: '5px' }} orientation="vertical" flexItem />
              <D size="0.5rem" />

              {this.state.selectedRows.length === 1 && (
                <>
                  <Tooltip title="Editar item" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <EditQuestion
                            edit
                            row={this.state.selectedRows[0]}
                            api={this.props.api}
                            alert={this.props.alert}
                            dialogClose={() => {
                              this.props.dialogClose();
                              this.setState({ selectedRows: [] });
                              this.updateData();
                            }}
                          />
                        )
                      }
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              {this.state.selectedRows.length > 0 && (
                <>
                  <Tooltip title="Excluir selecionados" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <ConfirmDialog
                            title="Excluir Itens"
                            msg="Ao confirmar, os itens serão excluídos e não poderão ser recuperados"
                            reg={
                              this.state.selectedRows.length > 1
                                ? this.state.selectedRows.length + " registros selecionados"
                                : "1 registro selecionado"
                            }
                            onCancel={this.props.dialogClose}
                            onConfirm={() => {
                              for (let row of this.state.selectedRows) {
                                this.props.api
                                  .delete("/Question/" + row.id)
                                  .then((r) => {
                                    this.props.alert(r.message);
                                    this.props.dialogClose();
                                    this.setState({ selectedRows: [] });
                                    this.updateData();
                                  })
                                  .catch(() => this.props.alert("Ocorreu um erro ao excluir o registro"));
                              }
                            }}
                          />
                        )
                      }
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              <D e />
              <Tooltip title="Inserir" arrow>
                <IconButton
                  sx={{ marginLeft: '12px' }}
                  onClick={() =>
                    this.props.dialog(
                      <EditQuestion
                        edit={false}
                        row={null}
                        api={this.props.api}
                        alert={this.props.alert}
                        dialogClose={() => {
                          this.props.dialogClose();
                          this.setState({ selectedRows: [] });
                          this.updateData();
                        }}
                      />
                    )
                  }
                >
                  <Add />
                </IconButton>
              </Tooltip>
          </>
        )}
          </D>
        <D h="1rem" />
        
        <Paper sx={{ width: '100%', height: '800px', overflow: 'hidden' }}>
          <DataGrid
            rows={dataTable}
            columns={this.columns}
            pagination
            paginationMode="server"
            rowCount={totalRows}
            loading={loading}            
            pageSizeOptions={[25, 50, 100]}
            paginationModel={{pageSize: pageSize, page: page} }
            onPaginationModelChange={this.handlePaginationModelChange}            
            disableSelectionOnClick
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          />
        </Paper>
      </D>
    );
  }
}


